const ParentName = ["总经理:总经理", "总监:总监", "会计:会计", "出纳:出纳",
    "助理:助理", "仓管员:仓管员", "质管员:质管员", "销售员:销售员", "部门经理:部门经理",
    "普通员工:普通员工"];

const flowName = [
    "SaleOrder: eMES销售订单", "SAPSaleOrder: sAP销售订单",
];

const statusText = [
    "启用: 启用", "禁用: 禁用",
];
const usePhase = [
    "开箱不良: 开箱不良",
    "使用3个月以内: 使用3个月以内",
    "使用超过1年: 使用超过1年",
];
const damageLocation = [
    "整流: 整流",
    "逆变: 逆变",
    "电容: 电容",
    "主控: 主控",
    "驱动: 驱动",
];
const siteEnvironment = [
    "工厂: 工厂",
    "车间: 车间",
    "家庭: 家庭",
    "其他: 其他",
];
const faultReporting = [
    "按键不良: 按键不良",
    "上电跳闸: 上电跳闸",
    "上电冒烟: 上电冒烟",
    "上电无反应: 上电无反应",
    "上电不吸合: 上电不吸合",
    "过流#140，A09: 过流#140，A09",
    "炸机: 炸机",
    "数码管显示不良（无显示或缺划）: 数码管显示不良（无显示或缺划）",
    "指示灯不亮: 指示灯不亮",
    "风扇不转/异响: 风扇不转/异响",
    "母线电压故障: 母线电压故障",
    "测试电机转动不良/不转: 测试电机转动不良/不转",
    "电机异响: 电机异响",
    "耐压NG: 耐压NG",
    "端子排变形/损坏: 端子排变形/损坏",
    "总线口通信NG: 总线口通信NG",
    "端口通信不良: 端口通信不良",
    "DSP程序烧录失败: DSP程序烧录失败",
    "CPLD/FPGA烧录失败: CPLD/FPGA烧录失败",
    "控制卡不识别: 控制卡不识别",
    "控制卡IO通讯异常: 控制卡IO通讯异常",
    "控制卡轴转异常: 控制卡轴转异常",
    "485通讯失败: 485通讯失败",
    "版本初始化失败: 版本初始化失败",
    "时间设定失败: 时间设定失败",
    "屏幕显示不异常、花屏、白屏: 屏幕显示不异常、花屏、白屏",
    "LED灯不亮: LED灯不亮",
    "手摇轮测试失败: 手摇轮测试失败",
    "U盘测试失败: U盘测试失败",
    "网口通讯失败: 网口通讯失败",
    "蜂鸣器不响、嘶哑、声音弱: 蜂鸣器不响、嘶哑、声音弱",
];
const SMTStationName = [
    "SMT SPI B面: SMT SPI B面",
    "SMT SPI T面: SMT SPI T面",
    "炉后目检1: 炉后目检1",
    "炉后目检T: 炉后目检T",
    "炉后目检2: 炉后目检2",
    "SMT 插件: SMT 插件",
    "焊后检查: 焊后检查",
    "ICT: ICT",
    "质量总检: 质量总检",
    "自动喷胶1: 自动喷胶1",
    "程序烧录: 程序烧录",
    "FCT测试: FCT测试",
    "老化前: 老化前",
    "老化后: 老化后",
    "SMT 自动喷胶2: SMT 自动喷胶2",
    "出厂程序烧录: 出厂程序烧录",
    "SMT 点胶: SMT 点胶",
];

const repairMan = [
    "张峰: 张峰", "吴伟龙: 吴伟龙", "金鸣华: 金鸣华",
];
const shelfCode = [
    "YDLC01: YDLC01", "YDLC02: YDLC02", "YDLC03: YDLC03", "YDLC04: YDLC04", "YDLC05: YDLC05", "YDLC06: YDLC06",
];
const extMaterialGroup1 = [
    "其他: 其他", "ST: ST", "GD: GD",
];
const extMaterialGroup = [
    "Z1: Z1", "Z2: Z2",
];

const RISK_CLASS = [
    "A: 高风险",
    "B: 中风险",
    "C: 低风险",
    " : ",
];

const BLOCK_REASON = [
    "01: 已超过信贷限额",
    "02: 不足分数",
    "03: 欺诈风险",
    "04: 不可保险",
];

const problemClassification_RJ = [
    "外观问题: 外观问题",
    "安装问题: 安装问题",
    "订单问题: 订单问题",
    "配置问题: 配置问题",
    "其他: 其他",
];
const problemClassification_LL = [
    "缺物料: 缺物料",
    "外观不良: 外观不良",
    "型号不良: 型号不良",
    "性能不良: 性能不良",
    "标识/结构不良: 标识/结构不良",
    "尺寸不良: 尺寸不良",
    "缺件: 缺件",
    "其他: 其他",
];

const locationNo = [
    "6101: 材料仓",
    "6102: 客供仓",
    "6201: 成品仓",
    "6202: 备品仓",
    "6301: 三楼产线(线边仓）",
    "6501: 维修组仓",
    "6502: 服务站备品仓",
    "6503: 备品仓",
    "6601: 待修仓",
    "6602: 待退仓",
    "6603: 报废仓",
    "6604: 不良品仓",
    "6605: 客退维修仓",
    "6606: 存货处置仓",
    "6901: 直发过账仓",
];
const returnType = [
    "0001: 质量低劣",
    "0002: 未完成的",
    "0003: 损坏的",
];

const taxCode = [
    "JD:13%进项税，中国",
];

// const departmentName = [
//   "总经办:总经办", "企业发展部:企业发展部",
//   "海外事业部:海外事业部","人力资源部:人力资源部","财务部:财务部",
//   "审计部:审计部","行政技术部:行政技术部","技术委员会:技术委员会",
//   "研发中心:研发中心","可靠性分析部:可靠性分析部","研发管理部:研发管理部",
//   "IT部:IT部","质量部:质量部","合同部:合同部","技术部:技术部",
//   "生产部:生产部","物流部:物流部","成品发运部:成品发运部","营销中心:营销中心",
//   "市场部:市场部","产品拓展部:产品拓展部","售前技术支持部:售前技术支持部",
//   "西部区:西部区","上海区:上海区","华南区:华南区","北方区:北方区",
//   "售后服务部:售后服务部","STEPSoft:STEPSoft","VIP客户订单处理:VIP客户订单处理",
//   "谊新国际:宜新国际","工艺及标准化部:工艺及标准化部","苏州区:苏州区",
//   "江苏区:江苏区","杭州区:杭州区","大客户部:大客户部","谊新财务部:谊新财务部",
//   "新时达股份:新时达股份","采购管理中心:采购管理中心","战略采购部:战略采购部",
//   "电机运营中心:电机运营中心","电机质量部:电机质量部","数据部:数据部",
//   "电机数据部:电机数据部","电机工艺部:电机工艺部","产品中心:产品中心",
//   "部件开发部:部件开发部","器件部:器件部","驱动产品研发:驱动产品研发",
//   "出口销售中心:出口销售中心","东南亚业务部:东南亚业务部","欧洲业务部:欧洲业务部",
//   "工控业务部:工控业务部","总经理办公室:总经理办公室",
//   "技术支持及售后服务中心:技术支持及售后服务中心","运控产品研发:运控产品研发",
//   "新时达运控事业部:新时达运控事业部","运控产品部:运控产品部",
//   "运控客服服务部:运控客服服务部","运控软件部:运控软件部","运控结构部:运控结构部",
//   "电气技术部:电气技术部","客户服务中心:客户服务中心","技术支持部:技术支持部",
//   "电机合同执行部:电机合同执行部","电梯硬件部:电梯硬件部","新时达电缆:新时达电缆",
//   "工艺部:工艺部","高压产品线:高压产品线","网络营销部:网络营销部",
//   "南浔区:南浔区","信息中心:信息中心","测试部门:测试部门","品质部:品质部",
//   "采购部:采购部","制造部:制造部","工程部:工程部","策划部:策划部",
//   "部件生产部:部件生产部","生产管理部:生产管理部","电气生产部:电气生产部",
//   "仓储部:仓储部","部门:部门","物联网研发部:物联网研发部",
// ];

let exportObj = {
    //departmentName,
    ParentName,
    flowName,
    SMTStationName,
    problemClassification_LL,
    problemClassification_RJ,
    statusText,
    repairMan,
    shelfCode,
    extMaterialGroup1,
    extMaterialGroup,
    RISK_CLASS,
    BLOCK_REASON,
    taxCode,
    locationNo,
    returnType,
    faultReporting,
    damageLocation,
    usePhase,
    siteEnvironment,
};

//------------------------------以下部分请勿改动------------------------------
//转化为object和options
for (let key in exportObj) {
    let value = exportObj[key];
    if (Array.isArray(value)) {
        let options = [];
        let object = {};
        value.forEach(item => {
            let itemArr = item.split(":");
            let option = {
                value: itemArr[0],
                label: itemArr[1],
            };
            object[option.value] = option.label;
            options.push(option);
        });
        value.$options = options;
        value.$object = object;
    }
}
export default exportObj;
